import {
  faExclamationCircle,
  faInfoCircle,
  faPlus,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  Table,
  UncontrolledDropdown,
} from "reactstrap";
import ButtonIcon from "../../common/ButtonIcon";
import Flex from "../../common/Flex";
import { VE_PHONE_FORMAT } from "../../../helpers/utils";
import PageHeader from "../../common/PageHeader";
import {
  createPriceRoot,
  editPriceRoot,
  getConfigAsRoot,
} from "../../../helpers/api/root";
import handleErrorMessage from "../../../helpers/errors/handleErrorMessage";
import { SUCCESS_RESPONSE } from "../../../helpers/codeResponses/codes";
import { Toast } from "../../UI/toast/Toast";
import { Message, Or, PreloadState } from "../../UI/preloading/PreloadState";
import { isIterableArray } from "../../../helpers/utils";
import ConfigRow from "./components/configRow";
import AddConfigRoot from "./components/addConfigRoot";
import useSWRFetchPagination from "../../../helpers/hooks/useSWRFetchPagination";
import { fetchLeads } from "../../../helpers/api/condominium";
import classNames from "classnames";
import { useSelector } from "react-redux";
import FullPagination from "../../common/pagination/FullPagination";
import FalconCardHeader from "../../common/FalconCardHeader";
import PayMethodAddModal from "../paymethods/components/PayMethodAddModal";
import LeadDetailsModal from "./components/LeadDetailsModal";
import NumberFormat from "react-number-format";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const RootLead = ({ setRedirect, setRedirectUrl }) => {
  const [ranges, setRanges] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submittingSave, setSubmittingSave] = useState(false);
  const [selected, setSelected] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const { role } = useSelector((state) => state.auth.user);
  const [min, setMin] = useState(1);
  const [max, setMax] = useState(2);
  const [price, setPrice] = useState(null);
  const toggle = () => setIsOpen(!isOpen);
  const [textSearch, setTextSearch] = useState("");
  const [params, setParams] = useState({
    search: null,
    textSearch: "",
  });
  const {
    data,
    isLoading,
    error,
    mutate,
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(fetchLeads, params);

  console.log(data);

  useEffect(() => {
    let isMounted = true;
    getConfig(isMounted);
    return () => {
      isMounted = false;
    };
  }, []);

  console.log(role)

  const getConfig = (isMounted) => {
    isMounted && setLoading(true);
    getConfigAsRoot()
      .then(({ data }) => {
        isMounted && setRanges(data);
      })
      .catch((error) => handleErrorMessage(error))
      .finally(() => {
        isMounted && setLoading(false);
      });
  };

  const saveRange = () => {
    setSubmittingSave(true);
    createPriceRoot(min, max, price)
      .then(({ code }) => {
        if (code === SUCCESS_RESPONSE.OK) {
          Toast.fire({
            title: "Configuración creada exitosamente.",
            type: "success",
          });
        }
      })
      .catch((error) => handleErrorMessage(error))
      .finally(() => {
        setSubmittingSave(false);
        setIsOpen(false);
        getConfig(true);
        setMin(1);
        setMax(2);
        setPrice(null);
      });
  };

  const handleEdit = async (provider) => {
    setRedirectUrl(`/dashboard/providers/edit/${provider}`);
    setRedirect(true);
  };



  const editRange = (id, min, max, price) => {
    setSubmitting(true);
    editPriceRoot(id, min, max, price)
      .then(({ code }) => {
        if (code === SUCCESS_RESPONSE.OK) {
          Toast.fire({
            title: "Configuración editada exitosamente.",
            type: "success",
          });
          getConfig();
        }
      })
      .catch((error) => handleErrorMessage(error))
      .finally(() => setSubmitting(false));
  };

  const closeBtn = (
    <>
      <Button
        className="close font-weight-normal bg-transparent border-0 shadow-none"
        onClick={toggle}
      >
        &times;
      </Button>
    </>
  );

  return (
    <>
      <PageHeader
        title="Leads"
        titleTag="h2"
        description="Gestiona los leads."
        className="mb-3"
        col={{ lg: 9 }}
      />

      <Card>
        <FalconCardHeader title="Leads">
          <Row>
            <Col xs={12} md={""} className="d-flex mb-2 mb-md-0">
              <Input
                type="text"
                value={textSearch}
                onKeyDown={(event) => {
                  if (event.key !== "Enter") return;
                  event.preventDefault();
                  const term = event.currentTarget.value.trim();
                  setTextSearch(term);
                  setParams((rest) => ({ ...rest, search: term || null }));
                }}
                onChange={(event) => {
                  const value = event.target.value;
                  setTextSearch(value);
                  if (value.trim() === "") {
                    setParams((rest) => ({ ...rest, search: null }));
                  }
                }}
                placeholder="Nombre, correo, teléfono, país, ciudad o rol"
                className="d-inline-block search-input mr-2"
              />
              <ButtonIcon
                icon={faSearch}
                className="d-inline-block text-nowrap"
                color="falcon-default"
                onClick={() => {
                  const term = textSearch.trim();
                  setTextSearch(term);
                  setParams((rest) => ({ ...rest, search: term || null }));
                }}
              >
                Buscar
              </ButtonIcon>
            </Col>
          </Row>
        </FalconCardHeader>
        <CardBody
          className={classNames("fs--1", { "p-0": isIterableArray(data) })}
        >
          <PreloadState cond={isIterableArray(data)} loading={isLoading}>
            <Table responsive className="mb-0">
              <thead>
                <tr>
                  <th weight="30%">Nombre</th>
                  <th>Correo electrónico</th>
                  <th>N° de teléfono</th>
                  <th weight="10%">Opciones</th>
                </tr>
              </thead>
              <tbody>
              {data?.map((lead, index) => (
  <tr key={index}>
    <td>{lead.name}</td>
    <td>{lead.email ? lead.email : "Correo no registrado"}</td>
    <td>
      {lead.phone ? (
        <NumberFormat
          type="tel"
          displayType="text"
          placeholder="Télefono"
          value={lead.phone}
          format={VE_PHONE_FORMAT}
        />
      ) : (
        "Teléfono no registrado"
      )}
    </td>
    <td>
      <Col xs="auto" className="d-sm-flex align-items-center">
        <UncontrolledDropdown
          direction="left"
          className="d-inline-block ml-2"
        >
          <DropdownToggle color="falcon-default" size="sm">
            <FontAwesomeIcon icon="ellipsis-h" />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              onClick={() => {
                setSelected({ ...data[index] });
                setIsOpen(true);
              }}
            >
              Detalles
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </Col>
    </td>
  </tr>
))}
        
              </tbody>
            </Table>
            <Or value={false} cond={!!error}>
              <Or value={false} cond={role}>
                <Or value={"root"} cond={!!textSearch[0]}>
                  <Message
                    value={true}
                    color={"info"}
                    className="p-3 mr-3"
                    align="left"
                    icon={faInfoCircle}
                  >
                    <>
                      No hemos encontrado un lead que coincida con{" "}
                      <b>"{textSearch}"</b>
                    </>
                  </Message>
                  <Message
                    value={false}
                    color={"info"}
                    className="p-3 mr-3"
                    align="left"
                    icon={faInfoCircle}
                  >
                    No hay leads registrados.
                  </Message>
                </Or>
          
              </Or>
            </Or>
            {/*   <Or value={false} cond={!!error}>
                        <Row value={false} className="p-card">
                            <Message className='p-2' icon={faInfoCircle} color={'info'}>
                                Al parecer aún no has creado un proveedor,
                                puedes crear uno ahora mismo pulsando el botón "Añadir proveedor"
                            </Message>
                        </Row>
                        <Row value={true} className="p-card">
                            <Col>
                                <Alert color="danger" className="mb-0">
                                    Esta página no está disponible
                                    <Button data-testid="Button" color="link" size="sm" className="ml-1 pl-0" onClick={() => { setRedirectUrl(`/dashboard/banks`); setRedirect(true) }}>
                                        Volver
                                    </Button>
                                </Alert>
                            </Col>
                        </Row>
                    </Or> */}
          </PreloadState>
        </CardBody>
        {isIterableArray(data) && (
          <CardFooter className="border-top">
            <FullPagination
              nextPage={nextPage}
              prevPage={previousPage}
              goToPage={goToPage}
              meta={meta}
              className={"shadow-none"}
              posText={"leads"}
              perPage={perPage}
            />
          </CardFooter>
        )}
      </Card>
      <LeadDetailsModal isOpen={isOpen} setIsOpen={setIsOpen} method={selected} setSelected={setSelected} mutate={mutate} />
    </>
  );
};

export default RootLead;
